export const getClientAccounts = (clients, selectedClientAccountId) => {

    const accounts = clients?.flatMap(c => c.clientAccounts);

    if(!selectedClientAccountId) return accounts;
    
    const accountSelected = selectedClientAccountId ? accounts.find(a => a.id == selectedClientAccountId) : null;
    let accountsFiltered = accountSelected ? accounts.filter(a => a.id == accountSelected.id) : [];

    if(accountSelected?.isDefault === true){
        accountsFiltered = accounts.filter(a => a.clientId === accountSelected.clientId);
    }
    
    return accountsFiltered;
};